
class QueryUtil {
  /**
   * Walk a Sequelize-style include tree. Promote any include with a where
   * clause (or a required descendant) to required: true, so that filters
   * actually drop parent rows instead of just nulling joined data.
   * Propagates upward so deeply-nested filters force ancestor joins to
   * INNER as well. If there's no where and no required descendant, clears
   * any prior required: true so the next fetch reverts to the LEFT JOIN
   * default. Explicit required: false is preserved. Mutates in place.
   */
  static promoteFilteredIncludes(include) {
  if (!Array.isArray(include)) return false;
  let anyChildRequired = false;
  include.forEach((inc) => {
    // Strip empty where objects — Sequelize treats their presence as a filter signal.
    if (inc.where && Object.keys(inc.where).length === 0) {
      delete inc.where;
    }
    const childRequired = QueryUtil.promoteFilteredIncludes(inc.include);
    const hasWhere = inc.where && Object.keys(inc.where).length > 0;
    if (inc.required !== false) {
      if (hasWhere || childRequired) {
        inc.required = true;
        anyChildRequired = true;
      } else if (inc.required === true) {
        delete inc.required;
      }
    }
  });
  return anyChildRequired;
}
}

export { QueryUtil };